export enum ListOfLanguages {
  EN = "en",
  PT = "pt",
}